import { TableHeadersType } from "./tableHeadersType";


export const USER_WORKING_ON_JOBS_HEADERS: TableHeadersType[] = [
  {
    "label": "EMPLOYEE",
    "value": "userName",
  
  },
  {
    "label": "DEPARTMENT",
    "value": "department",
  },
  {
    "label": "CHARGED HRS.",
    "value": "total_work_hours",
  },
  {
    "label": "SCHEDULED HRS.",
    "value": "scheduled_hours",
  },
];